import qs from 'qs'

// Init uses this code to select the Pixel. Registration may clear its own code,
// but this value survives until a new referral link or the browser clears storage.
const key = 'initAgentCode'
let memory = ''
const stores = ['localStorage', 'sessionStorage']

function normalize (code) {
  return typeof code === 'string' ? code.trim() : ''
}

function read (name) {
  try { return normalize(window[name].getItem(key)) } catch (e) { return '' }
}

export function agentCodeFromUrl () {
  const search = qs.parse(window.location.search.slice(1))
  const hash = window.location.hash || ''
  const index = hash.indexOf('?')
  const query = index < 0 ? {} : qs.parse(hash.slice(index + 1))
  return [query.agentCode, query.inviteCode, search.agentCode, search.inviteCode]
    .map(normalize).find(Boolean) || ''
}

export function getInitAgentCode (legacyCode) {
  // The current visit wins over stale shared storage (including failed quota writes).
  const code = agentCodeFromUrl() || memory || read('sessionStorage') || read('localStorage') || normalize(legacyCode)
  if (!code) return ''
  memory = code
  stores.forEach(name => {
    try { window[name].setItem(key, code) } catch (e) {}
  })
  return code
}

// Keep the parameter in the redirect URL when no storage survives navigation.
export function hasPersistedInitAgentCode (code) {
  return !!code && stores.some(name => read(name) === code)
}



// WEBPACK FOOTER //
// ./src/common/utils/initAgentCode.js